import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import AppTheme from '../shared-theme/AppTheme';
import AppAppBar from './components/AppAppBar';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

const divider = {
  background: 'linear-gradient(90deg, transparent, rgba(85,180,172,0.3), transparent)',
  height: '1px',
  border: 'none',
};

export default function MarketingPage(props) {
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <AppAppBar />
      <Hero />
      <Features />
      <Divider sx={divider} />
      <HowItWorks />
      <Divider sx={divider} />
      <Pricing />
      <Divider sx={{ ...divider, background: 'linear-gradient(90deg, transparent, rgba(24,88,107,0.3), transparent)' }} />
      <FAQ />
      <Divider sx={divider} />
      <Footer />
    </AppTheme>
  );
}
